export default __webpack_public_path__ + "static/media/dashboard-report-icon.947afb38.svg";